var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "9px",
    height: "16px",
    viewBox: "0 0 9 16",
    enableBackground: "new 0 0 9 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6B737B",
    d: "M1.126,0c0.288,0,0.576,0.111,0.795,0.335L8.67,7.191C8.881,7.405,9,7.697,9,8 C9,8.303,8.881,8.594,8.67,8.81l-6.746,6.854c-0.44,0.447-1.153,0.447-1.592,0c-0.44-0.445-0.44-1.17,0-1.617L6.281,8L0.331,1.953 c-0.44-0.446-0.44-1.171,0-1.618C0.55,0.111,0.838,0,1.126,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayarrow);
export default __webpack_public_path__ + "static/media/grayarrow.2642eba0754a7a04547d69dbe533b665.svg";
export { ForwardRef as ReactComponent };